import React from 'react';
import { CTAButton } from './CTAButton';
import { MockupImage } from './MockupImage';
import { TrustLine } from './TrustLine';
import { CHECKOUT_URL, PRODUCT, PRODUCT_TAGLINE } from '../data/constants';
const INCLUDED = ['6 comprehensive modules', '5 strategic bonuses', 'Fuel delivery & injection diagnostics', 'Ignition & misfire troubleshooting', 'Sensors, OBD-II & live data', 'VVT, emissions & drivability', 'Advanced diagnostic testing'];
export function Offer() {
  return <section id="offer" className="scroll-mt-2 border-y-4 border-diag bg-white py-6 sm:py-9" data-id="element-124" data-mp="p0a1b0srja40">
      <div className="mx-auto max-w-[1080px] px-4 sm:px-6" data-id="element-125" data-mp="13xkd6b9bii09">
        <p className="mx-auto w-fit bg-diag px-3 py-1 font-display text-[12px] font-semibold uppercase tracking-[0.2em] text-white sm:text-sm" data-id="element-126" data-mp="13uy76g22sak5">
          Special launch offer
        </p>

        <div className="mt-3 rounded-lg border-[3px] border-dashed border-diag bg-white" data-id="element-127" data-mp="2fad2lfemyud5">
          <div className="rounded-t-md bg-navy p-4 text-center sm:p-5" data-id="element-128" data-mp="2acl9ii29927d">
            <h2 className="text-[21px] leading-none text-white sm:text-[32px]" data-id="element-129" data-mp="pl0gu61v6gjo">🔧 {PRODUCT}</h2>
            <p className="mx-auto mt-2 max-w-[680px] text-[12.5px] font-semibold uppercase leading-tight tracking-wide text-steellight sm:text-[15px]" data-id="element-130" data-mp="uiiozu824rqm">
              {PRODUCT_TAGLINE}
            </p>
          </div>

          <div className="grid gap-4 p-4 sm:p-6 lg:grid-cols-[0.9fr_1.1fr] lg:items-center lg:gap-6" data-id="element-131" data-mp="13ip0jak73hn5">
            <MockupImage data-id="element-132" data-mp="6v0qlfuaeveo" />

            <div data-id="element-133" data-mp="6rms4ioqv6ci">
              <p className="font-display text-[16px] font-bold uppercase tracking-wide text-navy sm:text-[20px]" data-id="element-134" data-mp="bsu0aiusu7jp">
                Complete 6-in-1 System
              </p>
              <ul className="mt-2 grid gap-1.5" data-id="element-135" data-mp="ft4c4c59vs6h">
                {INCLUDED.map(item => <li key={item} className="flex items-start gap-2" data-id="element-136" data-mp="kmfcbufkxapf">
                    <span className="leading-snug" aria-hidden="true" data-id="element-137" data-mp="3k7kqorzmtklw">
                      ✅
                    </span>
                    <span className="text-[14px] font-semibold leading-snug text-navy sm:text-[16px]" data-id="element-138" data-mp="3o8o4za2178l0">
                      {item}
                    </span>
                  </li>)}
              </ul>

              <div className="mt-4 border-2 border-navy bg-mist px-3 py-3 text-center" data-id="element-139" data-mp="qejo3zp507jy">
                <p className="font-display text-[17px] font-bold uppercase leading-tight text-navy sm:text-[22px]" data-id="element-140" data-mp="154qv9j9p245c">
                  🔥 GET GASOLINE ENGINE DIAGNOSTIC PRO™ TODAY —{' '}
                  <span className="text-[24px] text-diag sm:text-[30px]" data-id="element-141" data-mp="chel68kpzosx">$26.90</span>
                </p>
              </div>

              <div className="mt-4 flex flex-col items-center" data-id="element-142" data-mp="7k4oq8ywycvl">
                <CTAButton href={CHECKOUT_URL} data-id="element-143" data-mp="licfu099qjyu">⚡ GET INSTANT ACCESS</CTAButton>
                <TrustLine items={['Immediate Digital Access', '🛡️ 7-Day Money-Back Guarantee']} data-id="element-144" data-mp="hfpu8h36xva3" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}